import React from 'react';

/** Card grid used on admin / super admin / supervisor dashboard home. */
export function DashboardCardSection({
  label,
  cards,
  onOpenCard,
  accent = 'amber',
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search forms…',
}) {
  const hoverBorder = accent === 'sky' ? 'hover:border-sky-300/50' : 'hover:border-amber-300/50';
  const hoverRing = accent === 'sky' ? 'focus:ring-sky-300/30' : 'focus:ring-amber-300/30';
  const titleHover = accent === 'sky' ? 'group-hover:text-sky-100' : 'group-hover:text-amber-100';
  const linkClass =
    accent === 'sky' ? 'text-sky-200/80 group-hover:text-sky-200' : 'text-amber-200/80 group-hover:text-amber-200';
  const sectionLabel =
    accent === 'sky' ? 'text-sky-200/80' : 'text-amber-200/80';
  const showSearch = typeof onSearchChange === 'function';

  return (
    <div className="mb-9">
      <div className={`flex flex-wrap items-center gap-2 mb-3.5 ${showSearch ? 'justify-between' : ''}`}>
        <h3 className={`text-sm font-semibold ${sectionLabel} uppercase tracking-wide`}>
          {label}
        </h3>
        {showSearch ? (
          <input
            type="search"
            value={searchValue || ''}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            aria-label={`Search ${label}`}
            className="w-full sm:w-56 max-w-full px-2.5 py-1.5 rounded-md bg-black border border-gray-700 text-xs text-gray-200 placeholder:text-gray-600 focus:outline-none focus:ring-1 focus:ring-amber-300/40 focus:border-amber-300/40"
          />
        ) : null}
      </div>
      {!cards.length ? (
        <p className="text-sm text-gray-500 py-4">
          {showSearch && (searchValue || '').trim()
            ? 'No forms match your search.'
            : 'No forms in this category.'}
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3.5">
          {cards.map((card) => (
            <button
              key={card.id}
              type="button"
              onClick={() => onOpenCard(card.id)}
              className={`group text-left px-4 py-3.5 rounded-xl border border-gray-800 bg-gray-950/80 ${hoverBorder} hover:bg-gray-900 transition-all focus:outline-none focus:ring-2 ${hoverRing}`}
            >
              <span className="text-xl mb-2 block" aria-hidden>
                {card.icon}
              </span>
              <h4 className={`text-[15px] font-semibold text-white ${titleHover} mb-1 leading-snug`}>
                {card.title}
              </h4>
              <p className="text-xs text-gray-400 leading-relaxed line-clamp-2">
                {card.description}
              </p>
              <span className={`inline-block mt-2.5 text-xs font-medium ${linkClass}`}>
                Open →
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
